<app-message [service]="messageService"></app-message>

<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" ngbAutoFocus>
  <div class="form-group" *ngIf="pricings">
    <div class="form-group">
      <label for="name" i18n="@@PricingNameLabel">Name*</label>
      <input type="text" id="name" formControlName="name" class="form-control" i18n-placeholder="@@PricingNamePlaceholder" placeholder="Name" />

      <div class="error">
        <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')" i18n="@@NameRequiredErrorMessage">Name wird benötigt</em>
      </div>
    </div>

    <div class="form-group">
      <label for="description" i18n="@@DescriptionLabel">Beschreibung</label>
      <textarea type="text" id="description" formControlName="description" class="form-control" i18n-placeholder="@@DescriptionPlaceholder" placeholder="Beschreibung" rows="2"></textarea>

      <div class="error">
        <em *ngIf="formService.validateControl('description') && formService.hasError('description', 'required')" i18n="@@DescriptionRequiredErrorMessage">Beschreibung wird benötigt</em>
      </div>
    </div>

    <div class="form-group">
      <label for="price" i18n-ngbTooltip="@@PriceNotEditableWarningTooltip" ngbTooltip="Bitte beachten Sie, dass eine nachträgliche Änderung des Preises nicht möglich ist, da dieser Gegenstand von Rechnungen wird. Sie können Sie stattdessen einen neuen öffentlichen Tarif hinzufügen.">Euro pro Kilowattstunde (kWh)*</label>
      <input type="number" id="price" formControlName="price" class="form-control" i18n-placeholder="@@CurrencyUnitPerKwhPlaceholder" placeholder="Euro pro Kilowattstunde (kWh)" />
      
      <div class="error">
        <em *ngIf="formService.validateControl('price') && formService.hasError('price', 'required')" i18n="@@PriceCurrencyUnitPerKwhRequiredErrorMessage">Euro pro Kilowattstunde (kWh) wird benötigt</em>
      </div>
    </div>
    <h5 i18n="@@PublicChargingHeader">Öffentliches Laden</h5>
    <ul>
      <li>
        <app-svg source="icons/feather/flag" height="24" i18n="@@ApplyPublicChargeModeMessage"></app-svg>
        Dieser Tarif gilt automatisch für alle Ladepunkte, die im Public Charge Modus sind.
      </li>
      <li>
        <app-svg source="icons/feather/link" height="24" i18n="@@PricingLinkMessage" ></app-svg>
        Öffentlich zugänglich wird der Tarif über einen Link zum Ladepunkt. Sie finden den Link in der Detail-Ansicht eines Ladepunkts.
      </li>
      <li>
        <app-svg source="icons/feather/smartphone" height="24" i18n="@@TakeToChargingPointMessage"></app-svg>
        Der Link führt Interessenten auf die Tarifseite des Ladepunkts, siehe Vorschau links.
      </li>
    </ul>
  </div>
</form>
